import { Component } from 'react';
import * as React from 'react';
import { Table } from 'react-bootstrap';

interface IAssetClassReturnsProps {
  displayClickHere?: boolean;
}

interface IAssetClassReturnsState {
  years: any[];
  rows: any[];
  hoverClass: string;
  dataThroughDate: string;
}

export class AssetClassReturns extends Component<IAssetClassReturnsProps, IAssetClassReturnsState> {
  state: IAssetClassReturnsState = {
    years: [],
    rows: [],
    hoverClass: '',
    dataThroughDate: '',
  };

  componentDidMount() {
    this.loadPerformanceTable();
  }

  public setTitleAndSubtitle() {
    const givTitleAndSubtitlePayload = {
      action: 'getGIVTrendTitleAndSubtitle',
      request: { assetLevel: 0, state: '', name: '', monthNumber: '12' },
    };
    fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', {
      method: 'POST',
      body: JSON.stringify(givTitleAndSubtitlePayload),
    })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&');
        text = text.replace(/\\/g, '');
        return JSON.parse(text);
      })
      .then((json) => {
        this.setState({ dataThroughDate: json.latestMonthYear });
      });
  }

  loadPerformanceTable() {
    const assetLevelRequest = { method: 'POST', body: JSON.stringify({ action: 'index', state: '', assetLevel: 0, monthNumber: 12 }) };
    fetch('https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark', assetLevelRequest)
      .then((resp) => resp.json())
      .then((json) => {
        const years = json.indexValues.years;
        const rows = [];
        rows.push(json.indexValues.rowOne);
        rows.push(json.indexValues.rowTwo);
        rows.push(json.indexValues.rowThree);
        rows.push(json.indexValues.rowFour);
        rows.push(json.indexValues.rowFive);
        rows.push(json.indexValues.rowSix);
        rows.push(json.indexValues.rowSeven);

        this.setState({ years, rows });
      });
  }

  updateHoverClass(event) {
    const hoverClass = event.type === 'mouseleave' ? '' : event.target.className.split(' ')[0];
    this.setState({ hoverClass });
  }

  render() {
    const { hoverClass, rows, years } = this.state;
    const { displayClickHere } = this.props;

    const title = displayClickHere ? (
      <b>
        <span>
          Click <a href="#/assetClassReturns">here</a> for more interactive visualizations
        </span>
      </b>
    ) : (
      ''
    );

    return (
      <section>
        <header style={{ fontSize: '1.6rem', color: '#00B050', textAlign: 'center' }}>{title}</header>
        <Table bordered style={{ textAlign: 'center', fontSize: '.9em' }}>
          <thead>
            <tr>
              {years.map((year, index) => {
                return (
                  <th key={year + index} style={{ textAlign: 'center' }}>
                    {year}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => {
              return (
                <tr key={index + Math.random()}>
                  {row.map((cell, index) => {
                    const classToAdd = cell.className + (hoverClass !== '' && cell.className !== hoverClass ? ' fade-class ' : '');
                    return (
                      <td
                        key={cell + index}
                        className={classToAdd}
                        onMouseEnter={this.updateHoverClass.bind(this)}
                        onMouseLeave={this.updateHoverClass.bind(this)}
                      >
                        {cell.abbreviation}
                        <br />
                        {cell.value.toFixed(1)}%
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/AssetClassReturns/index.tsx